import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation, } from '@angular/core';
import { KYMW7004Model } from './kymw7004.model';
import { Router } from '@angular/router';
import { GetFeatureRequestListService } from './api-services/get-feature-request-list.service';
import { UpdateFeatureRequestListService } from './api-services/update-feature-request-list.service';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { Menu } from '@grapecity/wijmo.input';
import { CollectionView, EventArgs, NotifyCollectionChangedAction, SortDescription } from '@grapecity/wijmo';
import { FlexGrid, CellType, CellRange, MergeManager, GridPanel, DataMap } from '@grapecity/wijmo.grid';
import { FlexGridFilter } from '@grapecity/wijmo.grid.filter';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { FeatureRequestInfo } from './vo/feature-request-info.model';

/**
 * 特集商品提案状況確認(CXデザイン部用)画面を管理するクラス
 * 
 * @export KYMW7004Component
 * @class KYMW7004Component
 */
@Component({
  selector: 'app-kymw7004',
  templateUrl: './kymw7004.component.html',
  styleUrls: ['./kymw7004.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7004Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  public model: KYMW7004Model = new KYMW7004Model();
  public collectionview: CollectionView;
  private contextForFeatureRequest: Menu;

  @ViewChild('dtg_FeatureRequestList', { static: true }) dtg_FeatureRequestList: FlexGrid;
  @ViewChild('flr_FeatureRequestList', { static: true }) flr_FeatureRequestList: FlexGridFilter;

  /** 特集商品提案状況一覧の背景色設定変数 */
  private BACK_WHITE = 'backgroud-color-white';
  private BACK_GRAY = 'backgroud-color-gray';

  /**
   * Creates an instance of KYMW7004Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetFeatureRequestListService} getFeatureRequestListService
   * @param {UpdateFeatureRequestListService} updateFeatureRequestListService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW7006Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getFeatureRequestListService: GetFeatureRequestListService,
    private updateFeatureRequestListService: UpdateFeatureRequestListService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private router: Router,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW7004Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW7004';

    // 初期表示用のAPIリクエスト
    this.getFeatureRequestListService.execute(this.model, () => {
      this.collectionview = new CollectionView(this.model.featureRequestList);

      // 同じ企画回の場合、セルを結合して表示
      this.gridInit();

      const catalogIdColumn = this.dtg_FeatureRequestList.columns.getColumn('CatalogId');
      if(catalogIdColumn && this.collectionview){
        catalogIdColumn.dataMap = this.getCatalogIdMap(this.collectionview.items);
      }
    });

    // コンテキストメニュー設定
    this.createContextMenu();
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW7004Component
   */
  public ngAfterViewInit(): void {
    // グリッドの初期状態で選択無効/チェックボックスのあたり判定
    if (this.dtg_FeatureRequestList) {
      this.dtg_FeatureRequestList.itemsSourceChanged.addHandler(
        (_g: FlexGrid, _e: EventArgs) => {
          _g.select(-1, -1);
        }
      );
      // セルクリック時にもチェックボックスを切り替える
      this.dtg_FeatureRequestList.hostElement.addEventListener('click', e => {
        if (this.isPermittedReadOnly) return;
        const ht = this.dtg_FeatureRequestList.hitTest(e);

        let model = this.collectionview.items[ht.row];
        if (model.disabled) return;
        
        if (ht.cellType === CellType.Cell && ht.col === 0) {
          const rng = this.dtg_FeatureRequestList.getMergedRange(this.dtg_FeatureRequestList.cells, ht.row, ht.col);
          if(rng){
            // 結合している場合
            // 結合範囲の先頭データを取得
            const firstRow = rng.topRow;
            const currentVal = this.dtg_FeatureRequestList.getCellData(firstRow, ht.col, false);

            if (this.checkAble(this.dtg_FeatureRequestList, rng)) {
              // 結合範囲全体に対して値を更新
              for (let r = rng.topRow; r <= rng.bottomRow; r++){
                this.dtg_FeatureRequestList.setCellData(r, ht.col, currentVal ? false : true);
              }
            }
          }      
        }
      });
      // ソートやフィルタリング実行時にセル結合し直す
      if (this.collectionview) {
        this.dtg_FeatureRequestList.collectionView.collectionChanged.addHandler((cv, eventArgs) => {
          if (eventArgs.action === NotifyCollectionChangedAction.Reset) {
            this.dtg_FeatureRequestList.invalidate();
          }
        });
      }
      // 特集商品提案状況一覧の企画回ごとの背景色設定
      this.dtg_FeatureRequestList.loadedRows.addHandler(() => {
        let rowNo = 0;
        for (const row of this.dtg_FeatureRequestList.rows) {
          if (row.index === 0) {
            row.cssClass = this.BACK_WHITE;
          }
          else {
            if (this.dtg_FeatureRequestList.rows[row.index - 1].dataItem.CatalogId !== row.dataItem.CatalogId) {
              rowNo++;
            }
            if (rowNo % 2 === 0) {
              row.cssClass = this.BACK_WHITE;
            } else {
              row.cssClass = this.BACK_GRAY;
            }
          }
        }
      });
    }
  }

  /**
   * グリッド初期処理
   *
   * @memberof KYMW7004Component
   */
  public gridInit() {
    // セル結合
    this.dtg_FeatureRequestList.mergeManager.getMergedRange = this.getMergedRange.bind(this);
  }

  /**
   * 結合範囲計算処理
   *
   * @memberof KYMW7004Component
   */
  public getMergedRange(p: GridPanel, r: number, c: number, clip: true) {
    const rng = new CellRange(r, c);
    const grid = p.grid; // FlexGridオブジェクト
    const column = grid.columns[c]; // 現在の列

    // 現在の列が取得できていない場合処理終了
    if (!column){
      return rng;
    }

    const field = column.binding; // 現在の列にバインドされているフィールド
    const items = (grid.itemsSource as CollectionView).items; // データソース
    
    // データがない場合処理終了
    if(!items || !field){
      return rng; 
    }
    
    // 企画回列とチェックボックス列を結合、他の列は結合しない
    if (field === 'CatalogId' || field === 'check'){
      // 企画回(CatalogId)列を基準に結合
      const keyField = 'CatalogId'; 
      for (let i = rng.row; i < p.rows.length - 1; i++) {
        if (items[i][keyField] !== items[i + 1][keyField]) break;
        rng.row2 = i + 1;
      }
      for (let i = rng.row; i > 0; i--) {
        if (items[i][keyField] !== items[i - 1][keyField]) break;
        rng.row = i - 1;
      }
    }

    return rng;
  }

  /**
   * コンテキストメニュー 企画回特集確認・企画回特集履歴確認
   *
   * @memberof KYMW7004Component
   */
  private checkSpecialFFeature() {
    if (!(this.dtg_FeatureRequestList.selectedItems[0] instanceof FeatureRequestInfo)) return;
    const selFeatureRequest = this.dtg_FeatureRequestList.selectedItems[0];

    // 特集商品選定画面を呼び出す
    // 遷移先でthis.router.getCurrentNavigation()を使用してstateの値を取得
    const data = { 
      catalogId: selFeatureRequest.CatalogId,
      catalogIdName: this.formatCatalogId(selFeatureRequest.CatalogId),
      orderCode: selFeatureRequest.OrderCode,
      mediumType: selFeatureRequest.MediumType };
    // 遷移先とパラメータを設定
    this.router.navigate(['/kymw/7005'], { queryParams: data });
  }

  /**
   * コンテキストメニュー作成
   *
   * @memberof KYMW7004Component
   */
  private createContextMenu(): void {
    this.contextForFeatureRequest = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '企画回特集確認', cmd: 'checkCatalogId', enabled: true },
        { caption: '企画回特集履歴確認', cmd: 'checkCatalogIdHistory', enabled: true },
      ],
      command: {
        canExecuteCommand: param => {
          return param.enabled === false ? false : true;
        },
      },
      itemClicked: () => {
        if (this.contextForFeatureRequest.selectedValue === 'checkCatalogId') this.checkSpecialFFeature();
        if (this.contextForFeatureRequest.selectedValue === 'checkCatalogIdHistory') this.checkSpecialFFeature();
      },
    });

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_FeatureRequestList.hostElement.addEventListener('contextmenu', e => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextForFeatureRequest !== undefined) {
        const ht = this.dtg_FeatureRequestList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const grid = new CellRange(ht.row, ht.col);
          this.dtg_FeatureRequestList.select(grid, false);
        }
        // コンテキストメニュー項目活性・非活性制御呼出
        this.eventContextMenu_Handler();
        // メニュー表示
        this.contextForFeatureRequest.show(e);
      }
    });

  }

  /**
   * コンテキストメニュー項目活性・非活性制御
   *
   * @memberof KYMW6800Component
   */
  private eventContextMenu_Handler(): any {
    this.contextForFeatureRequest.itemsSource.forEach(item => {
      // 選択行の付替ステータスが「1:付替中」の場合、コンテキストメニューを企画回特集確認活性させる
      if(item.caption === '企画回特集確認' && this.dtg_FeatureRequestList.selectedItems[0].ReplacementStatus === 1){
        item.enabled = true;
        // 選択行の付替ステータスが「2:付替済み」の場合、コンテキストメニューの企画回特集履歴確を活性させる
      }else if(item.caption === '企画回特集履歴確認' && this.dtg_FeatureRequestList.selectedItems[0].ReplacementStatus === 2){
        item.enabled = true;
      }else{
        item.enabled = false;
      }
    });
  }

  /**
   * 確定ボタン押下 データと画面内容の更新
   *
   * @memberof KYMW7004Component
   */
  public update(): void {
    const items = (this.dtg_FeatureRequestList.itemsSource as CollectionView).items;

    // バリデーション 選択チェック
    if (items.filter(_f => _f.check).length === 0) {
      this.dialogService.openAlertGetMessage('E0103', ['確定したい企画回']);
      return;
    }

    // 確認ダイアログの表示
    this.dialogService.openAlertGetMessage('Q0167', [], _c => {
      // 「はい」を選択した場合、処理継続
      if (_c === PlessAlert.Yes) {
        // 更新処理呼出し
        this.updateFeatureRequestListService.execute(this.model, () => {
          // 処理成功した場合、更新結果ダイアログの表示
          this.dialogService.openAlertGetMessage('I0508', ['特集商品の選定確定'], _e => {
            if (_e === PlessAlert.Yes) {
              // 特集商品提案状況一覧取得の呼び出し
              this.getFeatureRequestListService.execute(this.model, () => {
                this.collectionview = new CollectionView(this.model.featureRequestList);
          
                // 同じ企画回の場合、セルを結合して表示
                this.gridInit();
              });
              this.createContextMenu();
            }
          });
        });
      }
    });
  }

  /**
   * チェックボックスの権限確認
   *
   * @memberof KYMW7004Component
   */
  public isPermittedCheck(e: Event){
    if (this.isPermittedReadOnly){
      e.preventDefault();
      return;
    } 
  }
  /**
   * チェックボックスのchangeイベント
   *
   * @memberof KYMW7004Component
   */
  public onCheckChange(item: any, e: Event): void {
    
    const grid = this.dtg_FeatureRequestList;
    const checkbox = e.target as HTMLInputElement;
    // 行番号取得
    const rowIndex = grid.itemsSource.items.findIndex(row => row === item);
    const range = grid.getMergedRange(this.dtg_FeatureRequestList.cells, rowIndex, grid.columns.findIndex(c => c.binding === 'check'));
    
    // チェックボックスの変更可否チェック呼出し
    if(!this.checkAble(this.dtg_FeatureRequestList, range)){
      // チェックを外す
      checkbox.checked = false; 
      // 同じ企画回のcheckを変更   
      this.collectionview.items.filter(_ => {
        if (_.CatalogId === item.CatalogId) _.check = false;
        return _.CatalogId === item.CatalogId;
      });
      
      return;
    }

    // 同じ企画回のcheckを変更
    this.collectionview.items.filter(_ => {
      if (_.CatalogId === item.CatalogId) _.check = checkbox.checked;
      return _.CatalogId === item.CatalogId;
    });
  }

  /**
   * チェックボックスの変更可否
   *
   * @memberof KYMW7004Component
   */
  public checkAble(f: FlexGrid, r: any): boolean {
    let canCheck = true;
    const items = (f.itemsSource as CollectionView).items;
    if (r instanceof CellRange) {
      for (let rt = r.topRow; rt <= r.bottomRow; rt++) {
        const item = items[rt];
        if (item.SelectionFlag !== 2) {
          canCheck = false;
          break;
        }
      }
    }

    if(!canCheck){
      this.dialogService.openAlertGetMessage('E0538');
    }

    return canCheck;
  }

  /**
   * 企画回表示用処理
   *
   * @memberof KYMW7004Component
   */
  formatCatalogId(catalogId: string) {
    const year = catalogId.substring(0, 4);
    const month = catalogId.substring(4, 6);
    const day = catalogId.substring(6, 8);
    return `${year}年${month}月${day}回`;
  }

  /**
   * フィルターでの企画回表示形式変更処理
   * wijmoのフィルター内で実際の値と表示用の値をマッピング
   *
   * @memberof KYMW7004Component
   */
  getCatalogIdMap(items: any[]): DataMap {
    const unique = new Map<string, string>();
   
    // 重複したCatalogIdは弾いた上で、整形した表示用文字列と結びつける
    items.forEach(item => {
      const key = item.CatalogId;
      if (!unique.has(key)) {
        unique.set(key, this.formatCatalogId(key));
      }
    });
   
    // DataMap用の配列に変換
    const map = Array.from(unique.entries()).map(([key, formatted]) => ({
      key,
      formatted
    }));
    
    // wijmo.DataMapを作成し、key(実際の値)とformatted(表示用の値)を紐付けて返す
    return new DataMap(map, 'key', 'formatted');
  }
}
